module.exports = __webpack_public_path__ + "static/img/easy@2x.1351f1ac.png";